// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__jYNXj","tableRow":"styles_tableRow__2Sb3I","sorted":"styles_sorted__2Zvrd","btn":"styles_btn__ZkASU"};